import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { useIntercom } from "react-use-intercom";
import SideBar from "../../Sections/SideBar";
import Navbar from "../../Sections/NavBar";
import MobileNav from "../../Sections/MobileNav";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../../app-store/userSlice";
import ConfirmPurchase from "./ConfirmPurchase";
import Status from "./Status";
import httpClient from "../../../custom-hooks/httpClient";
import InitiateTransfer from "./InitiateTransfer";
import TwoFactorAuth from "../../2FA-OTP";

function DataSubscription() {
  const userId = localStorage.getItem("id");
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const { boot } = useIntercom();
  const [stage, setStage] = useState("initiate"); // initiate, confirm, authenticate, status
  const [transferDetails, setTransferDetails] = useState({
    transaction_pin: "",
    amount: "",
    dataplan: "",
    phoneNumber: "",
    network: "",
    wallet_account_number: "",
    wallet_name: "",
  });

  const [transferStatus, setTransferStatus] = useState("");
  const [transferReference, setTransferReference] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [notificationChannel, setNotificationChannel] = useState("");
  const [recipient, setRecipient] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChangeTransferDetails = (e) => {
    // Handle cases where the function is called with either a single event or an array of events and stores the updated transfer details inside temp.
    e = Array.isArray(e) ? e : [e];
    const temp = {};
    // Collect the updated transfer details from the array of events above and then updates the transfer details state.
    for (const event of e) {
      if (event.target.name === "wallet_account_number") {
        const selectedWallet = user.wallets.find(
          (wallet) => wallet.account_no === event.target.value
        );
        temp["wallet_account_number"] = selectedWallet.account_no;
        temp["wallet_name"] = selectedWallet.name;
      } else {
        temp[event.target.name] = event.target.value;
      }
    }

    setTransferDetails({
      ...transferDetails,
      ...temp,
    });
  };

  const handleInitiateTransfer = (e) => {
    e.preventDefault();
    setStage("confirm");
  };

  const onConfirm = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    // Set transfer amount to number
    const transfer = {
      ...transferDetails,
      dataplan: JSON.parse(transferDetails.dataplan).DATA_PLAN,
      amount: Number(transferDetails.amount),
      phoneNumber: `234${transferDetails.phoneNumber.substring(1)}`,
    };

    try {
      const { status, data } = await httpClient.post(`/data/buy-data`, {
        ...transfer,
      });

      if (status === 202) {
        setNotificationChannel(data.notificationChannel);
        setRecipient(data.recipient);
        setStage("authenticate");
      }
      if (status === 201) {
        setTransferReference(data.transaction.userReference);
        setTransferStatus("successful");
        setStage("status");
      }
    } catch (err) {
      setIsProcessing(false);
      toast.error(err.response.data.message);
      setTransferStatus("failed");
      setStage("status");
    }
  };

  const handleConfirmTransfer = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    // Set transfer amount to number
    const transfer = {
      ...transferDetails,
      dataplan: JSON.parse(transferDetails.dataplan).DATA_PLAN,
      amount: Number(transferDetails.amount),
      phoneNumber: `234${transferDetails.phoneNumber.substring(1)}`,
    };
    const otp = document.getElementById("otp").value; // Get OTP from user input.

    try {
      const { status, data } = await httpClient.post(`/data/buy-data`, {
        ...transfer,
        otp,
      });

      setIsProcessing(false);

      if (status === 201) {
        setTransferReference(data.transaction.userReference);
        setTransferStatus("successful");
        setStage("status");
      }
    } catch (err) {
      // Check for 401 with "invalid otp" message
      if (
        err.response?.status === 401 &&
        err.response?.data?.message === "Invalid otp"
      ) {
        setErrorMessage("Invalid OTP! Please, check and try again.");
        document.getElementById("otp").value = ""; // Reset OTP input field.
        setIsProcessing(false);
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      } else {
        const errorMessage =
        err.response && err.response.data
          ? err.response.data.message
          : "Error initiating data purchase";
        toast.error(errorMessage);
        setTransferStatus("failed");
        setStage("status");
      }
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    httpClient
      .get(`/users/${userId}`)
      .then(({ status, data }) => {
        if (status === 200) {
          dispatch(setUser(data.user));
          boot({
            name: `${data.user.first_name} ${data.user.last_name}`,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error getting user");
      });
  }, [userId, dispatch, boot]);

  if (!user) {
    return (
      <div
        className="text-center align-items-center"
        style={{ marginTop: "25%" }}
      >
        <Loader type="Oval" color="#1c743a" />
      </div>
    );
  }

  return (
    <>
      <Navbar dashboard />
      <MobileNav />
      <section>
        <div className="container-fluid">
          <div className="row">
            <SideBar />
            <div className="col-12 col-lg-6 col-xl-8 offset-lg-3 offset-xl-2 py-7 py-lg-9 px-lg-7">
              {stage === "initiate" && (
                <InitiateTransfer
                  user={user}
                  handleInitiateTransfer={handleInitiateTransfer}
                  handleChangeTransferDetails={handleChangeTransferDetails}
                  transferDetails={transferDetails}
                />
              )}
              {stage === "confirm" && (
                <ConfirmPurchase
                  handleChangeTransferDetails={handleChangeTransferDetails}
                  transferDetails={transferDetails}
                  isProcessing={isProcessing}
                  onConfirm={onConfirm}
                />
              )}
              {stage === "authenticate" && (
                <TwoFactorAuth
                  handleConfirmTransfer={handleConfirmTransfer}
                  notificationChannel={notificationChannel}
                  recipient={recipient}
                  errorMessage={errorMessage}
                />
              )}
              {stage === "status" && (
                <Status
                  transferDetails={transferDetails}
                  transferStatus={transferStatus}
                  transferReference={transferReference}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default DataSubscription;
